import { appStoreConstant } from "@/utils/branch"
import {
	useEditorParamsContext,
	useUploadOption,
} from "sections/editor/editor"
import { z } from "zod"
import Button, { ConditionalAnchor } from "../button"

const featureAiToolSchema = z.enum([
	"deform",
	"ai_photo",
	"ai_restyle",
	"text_to_image",
	"text_to_video",
	"ai_music_generator",
])

export const styleSchema = z.object({
	component: z.literal("styles"),
	title: z.string(),
	text: z.string(),
	button_text: z.string(),
	button_link: z.string().optional(),
	media_light: z.string(),
	media_dark: z.string(),
	alt: z.string().optional(),
	upload: z.boolean().optional(),
	tool: featureAiToolSchema.optional(),
})

export type Style = z.infer<typeof styleSchema>

export default function Styles(props: Style) {
	const {
		title,
		text,
		button_text,
		button_link,
		media_dark,
		media_light,
		upload,
		tool,
		alt,
	} = props

	const { onClick } = useUploadOption(upload, tool)
	const editor = useEditorParamsContext()

	return (
		<>
			<div className="z-20 w-full px-4 py-[16px] tablet:flex tablet:justify-center tablet:py-[40px] desktop:justify-center desktop:py-[55px]">
				<div className="flex w-full flex-col items-center gap-5 rounded-[14px] bg-color-background px-5 py-9 tablet:w-[729px] tablet:gap-10 tablet:pl-8 desktop:w-[1175px] desktop:flex-row desktop:justify-between desktop:rounded-[20px] desktop:pl-16">
					<div className="flex w-full flex-col items-center gap-5 tablet:gap-10 desktop:w-[642px] desktop:items-start">
						<div className="flex flex-col items-center gap-5 tablet:px-11 desktop:items-start desktop:px-0">
							<h4 className="desktop:text-h5 text-h2 text-center desktop:text-start">
								{title}
							</h4>
							<img
								src={media_light}
								alt={alt}
								className="dark:hidden desktop:hidden"
							/>
							<img
								src={media_dark}
								alt={alt}
								className="hidden dark:block dark:desktop:hidden"
							/>
							<p className="text-body-3 px-3 text-center tablet:px-0 desktop:text-start">
								{text}
							</p>
						</div>
						{tool !== "ai_music_generator" && (
							<>
								<Button
									href={button_link}
									onClick={() => {
										onClick && onClick()
									}}
									loading={editor.loading}
									className="hidden w-full tablet:w-[50%] desktop:block desktop:w-[50%]"
									text={button_text}
									primary
								/>
								<ConditionalAnchor
									href={appStoreConstant}
									className="w-full tablet:w-[50%] desktop:hidden">
									{button_text}
								</ConditionalAnchor>
							</>
						)}
						{button_text &&
							tool === "ai_music_generator" && (
								<Button
									loading={editor.loading}
									primary
									onClick={onClick}
									text={button_text}
									className="w-full tablet:w-[50%]"
								/>
							)}
					</div>
					<img
						src={media_light}
						alt={alt}
						className="hidden dark:hidden tablet:max-w-[300px] desktop:block desktop:max-h-[546px] desktop:max-w-[500px]"
					/>
					<img
						src={media_dark}
						alt={alt}
						className="hidden tablet:max-w-[300px] desktop:max-h-[546px] desktop:max-w-[500px] dark:desktop:block"
					/>
				</div>
			</div>
		</>
	)
}
